import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { SET_CURRENT_COUNTRY } from './currentCountryActions'

const initialState = fromJS({
  isLoaded: false,
})

export default createReducer(initialState, {
  // SET_CURRENT_COUNTRY is hand-written and carries the country on `action.val`.
  // The payload fully replaces the previous country. Merging would retain fields the new
  // country omits, including a stale childTriagePolicy or its trailing competency bands.
  [SET_CURRENT_COUNTRY]: (_$$state: $TSFixMe, action: $TSFixMe) => fromJS(action.val ?? {}).set('isLoaded', true),
})
